// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"511":"49156860","690":"de5ab970","742":"0b48200a"}[chunkId] + ".chunk.js";
};